
    <div [class]="computedSpinnerClasses()" [attr.aria-label]="label || 'Loading'">
      <!-- Circular Spinner -->
      @if (type === 'circular') {
      <div [class]="computedCircularClasses()"></div>
      }

      <!-- Dots Spinner -->
      @if (type === 'dots') {
      <div [class]="computedDotsClasses()">
        <div class="w-2 h-2 rounded-full animate-bounce" style="animation-delay: 0ms;"></div>
        <div class="w-2 h-2 rounded-full animate-bounce" style="animation-delay: 150ms;"></div>
        <div class="w-2 h-2 rounded-full animate-bounce" style="animation-delay: 300ms;"></div>
      </div>
      }

      <!-- Pulse Spinner -->
      @if (type === 'pulse') {
      <div [class]="pulseClasses()" class="rounded-full animate-pulse"></div>
      }

      <!-- Bars Spinner -->
      @if (type === 'bars') {
      <div class="flex items-end space-x-1">
        @for (bar of [1,2,3,4]; track bar) {
        <div [class]="barClasses()" class="rounded-sm animate-pulse" [style.animation-delay]="bar * 150 + 'ms'"></div>
        }
      </div>
      }

      <!-- Ring Spinner -->
      @if (type === 'ring') {
      <div class="relative">
        <div [class]="ringOuterClasses()" class="rounded-full animate-spin"></div>
        <div [class]="ringInnerClasses()" class="absolute inset-2 rounded-full animate-spin-reverse"></div>
      </div>
      }

      <!-- Orbit Spinner -->
      @if (type === 'orbit') {
      <div class="relative">
        <div
          [class]="orbitCenterClasses()"
          class="absolute inset-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full"
        ></div>
        <div [class]="orbitRingClasses()" class="rounded-full animate-spin">
          <div
            [class]="orbitDotClasses()"
            class="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full"
          ></div>
        </div>
      </div>
      }

      <!-- Glass shimmer effect for premium -->
      @if (variant === 'premium') {
      <div class="absolute inset-0 opacity-60 animate-pulse rounded-full overflow-hidden">
        <div
          class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/30 to-transparent
                      transform -skew-x-12 animate-pulse
                      transition-transform duration-2000 ease-out"
        ></div>
      </div>
      }
    </div>

    <!-- Optional label -->
    @if (showLabel && label) {
    <div class="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
      {{ label }}
    </div>
    }
  